<template>
  <div class="about">
  <div class="heade" v-if="newstatus=='0' || newstatus=='1'">
   
    <van-button plain type="default" size="small" style="margin-left:20px" @click="viewPage()" >编辑</van-button>
    <!-- <van-button plain type="default" size="small" @click="back()">退出</van-button> -->
  </div>
  <div class="successTitle">
    <van-image width="30" height="30" v-if="newstatus=='3'" :src="iconsone"/>
     <van-image width="30" height="30" v-else :src="icons"/>
    <!-- <p>{{success_msg}}</p> -->
    <p>{{status_format}}</p>
    
    <p v-if="newstatus=='3'">原因:{{status_remarks}}</p>
  </div>
  <van-cell-group v-for="(item, index) in dataList" :key="index">
    <div v-if="item.attr_code == 'file' " class="fileInput">
      <p>{{item.attr_name}}:</p>
      <van-image
        width="20"
        height="20"
        fit="contain"
        :src="item.value"
      />
    </div>
    <div v-if="item.attr_code == 'paragraph'" :style="{ color: item.attr_setting.color, fontSize: '0.3rem',fontWeight:'800',background: '#f6f6f6',padding: '0.3rem'}" >
      {{item.field_name}}
    </div>
    <van-field v-else-if="item.attr_code == 'description'" readonly v-model="item.value" :label="item.attr_name" type="textarea"/>
    <div v-else-if="item.attr_code == 'image'" class="imgInput">
      <p>{{item.attr_name}}:</p>
      <div v-for="(items, index) in item.value" :key='index'>
        <van-image
          width="50"
          height="50"
          fit="contain"
          :src="items"
        />
      </div>
    </div>
    <van-field v-else v-model="item.value" readonly :label="item.field_name"/>
  
  </van-cell-group>
  <div style="height:70px"></div>
  <div class="myfooters">
    
   
    <van-button  type="info"  size="normal" v-if="is_open.is_open_print=='1'" style="width:130px" @click="onedowns()">下载准考证</van-button>
    <van-button  type="info"  v-if="is_open.is_open_fraction=='1'"  size="normal" style="width:130px" @click="views()">查看成绩</van-button>
  </div>
  </div>
</template>
<script>
import { information,getbtnmation } from '@/api/login/login.js';
import {getInfo, getSchool, removeSchoolItem, removeSchool, removeToken} from '@/utils/auth.js';
import { mapGetters, mapMutations } from 'vuex';
import  areaList  from '@/assets/js/area.js'
import icons from '@/assets/icon_sucess.png';
import iconsone from '@/assets/icon_unsupport.png';

// import { Dialog } from 'vant';
import Dialog from 'vant';
export default {
  data(){
    return {
      dataList:[],
      icons,
      iconsone,
      success_msg:'',
      is_open:'',
      newstatus:'',
      status_format:'',
      status_remarks:"",
    }
  },
  created(){
    this.getInformation()
    // 获取按钮
    this.getbtn()
    this.success_msg=sessionStorage.success_msg

  },
  mounted(){
      if( sessionStorage.login_notice_status=='true'){
            // 展示弹框
            this.$dialog.confirm({
                // title: '标题',
                message: sessionStorage.login_notice_content,
                showCancelButton:false,
                confirmButtonText:'我知道了'
            })
            .then(() => {
                // on confirm
            })
            .catch(() => {
                // on cancel
            });
      }
  },
  methods:{
      /**
     * 获取按钮
     * @method getbtn
     */
    getbtn(){
      let obj = JSON.parse(getInfo());
      let formData = new FormData();
      formData.append('request', JSON.stringify({'project_id': JSON.parse(getSchool()).project_id}));
      getbtnmation(formData).then( res => {
        if (res.code == 0) {
       
          this.is_open = res.data;
        }else {
          this.$toast(res.msg);
        }
      }).catch(error=>{
        this.$toast('请联系管理员');
      })
    },
    // 下载准考证
    onedowns(){
     
       this.$router.push({path:'/downloads', query:{code: this.$route.query.code}})
    },
    // 查看成绩
    views(){
        this.$router.push({path:'/achievement', query:{code: this.$route.query.code}})
    },
    /**
     * 获取个人信息
     * @method getInformation
     */
    getInformation(){
      let obj = JSON.parse(getInfo());
      let formData = new FormData();
      formData.append('request', JSON.stringify({'project_id': JSON.parse(getSchool()).project_id, 'stu_id':obj.stu_id}));
      information(formData).then( res => {
        if (res.code == 0) {
          res.data.forEach(item => {
            if(item.attr_code == 'region'){
              if(item.value != ''){
                item.value = `${areaList.province_list[item.value[0]]} ${areaList.city_list[item.value[1]]} ${areaList.county_list[item.value[2]]}`
              }
            }
          });
          this.dataList = res.data;
          // 状态
          this.newstatus=res.status
           this.status_format=res.status_format
          this.status_remarks=res.status_remarks
          // debugger

        }else {
          this.$toast(res.msg);
        }
      }).catch(error=>{
        this.$toast('请联系管理员');
      })
    },
    /**
     * 退出btn
     * @method back
     */
    back(){
      removeSchoolItem();
      removeSchool();
      removeToken();
      this.$router.push({path:'/login', query:{code: this.$route.query.code}})
    },
    /**
     * 跳转编辑页面
     * @method viewPage
     */
    viewPage(){
      this.$router.push({path:'/edit', query:{code: this.$route.query.code}})
    }
  },
  computed: {
    ...mapGetters([
      'schoolItem',
      'school'
    ]),
  }
}
</script>
<style lang="scss" scoped>
.imgInput{
  display: flex;
  align-items:center;
  border: none;
  padding: 10px 0;
  p{
    font-size:14px; 
    margin: 10px 32px 10px 16px;
  }
}
.fileInput{
  display: flex;
  align-items:center;
  border: none;
  padding: 10px 0;
  p{
    font-size:14px; 
    margin: 10px 32px 10px 16px;
  }
}
.heade{
  // padding: 0 20px;
  // margin-left: 20px;
  height: 40px;
  // width: 100%;
  width: calc(100% - 20px);
  border: 1px solid #f3f3f3;
  display: flex;
  justify-content: space-between;
  align-items: center;

}
.myfooters{
  height: 50px;
  position: fixed;
  bottom: 0px;
  // background: red;
   padding: 0 20px;
  // width: 100%;
  width: calc(100% - 40px);
  // border: 1px solid #f3f3f3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.successTitle{
  // padding: 0 10px;
  height: 120px;
  // width: 100%;
  // width: calc(100% - 20px);
  border: 1px solid #fff;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p{
    margin-top: 10px;
  }
}
</style>